<div class="w-full h-full md:p-12 p-5 overflow-y-scroll hide-bar" *transloco="let t">
  <std-modal  cardClass="!max-w-[90vw]" cardClass="!max-w-[90vw]" headerClass="bg-primary" [show]="showModalDelete" [closeOnOutside]="false" (close)="listOfProducts = [];showModalDelete=false;selectedIndexProductToAdd = -1">
    <div class="text-tertiary text-large" header>{{t('modal.delete')}}</div>
    <div content class="max-h-[70vh] overflow-y-scroll custom-scrollbar">
        <div class="text-primary text-medium">{{t('modal.confirmation')}}</div>
        <div class="mt-4 flex gap-4">
            <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary" (click)="showModalDelete = false" class="">{{t('modal.cancel')}}</std-button>
            <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary" (click)="deleteElement(t)" class="">{{t('modal.confirm')}}</std-button>
        </div>
    </div>
</std-modal>
  <div class="flex">
    <div class="w-[250px] ml-auto">
      <std-select (onChangeValue)="getReceipts($event)" [data]="mySalons" [label]="t('selectSalon')" bindValue="id"
        bindLabel="name" [placeholder]="t('selectSalon')" customLabel="label-input"
        customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
        customClassContaier="custom-select"></std-select>
    </div>
   @if(mySalon){<div class="w-[250px] ml-4"> <std-button (click)="showAdd = true" buttonClass="bg-primary focus:bg-primary hover:bg-primary"
      (click)="showAdd = true">{{t('add')}}</std-button></div>}
  </div>
  <div class="my-4 items-center gap-8">
    <div class="rounded-xl">
      <div class="md:max-w-[calc(100vw-317px)] md:overflow-x-scroll custom-scroll mb-4"> <std-table
          class="hide-bar-all bg-secondary  fix-table" [data]="dataTable" tableContainerClass="bg-secondary "
          headerClass=" bg-primary focus:bg-primary hover:bg-primary">
          <span stdoutTableColumn width="110" [label]="t('date')">
            <ng-template #dataTableCell let-item="item">
               <div class="flex items-end gap-5">
                    {{getFormattedDate(item.createdAt)}}
                </div>
            </ng-template>
        </span>
          <span stdoutTableColumn width="110" [label]="t('price')" property="startPrice"></span>
          <span stdoutTableColumn width="110" [label]="t('discount')" property="discount"></span>
          <span stdoutTableColumn width="110" [label]="t('total')" property="total"></span>

          <span stdoutTableColumn width="110" [label]="t('actions')">
            <ng-template #dataTableCell let-item="item">
              <div class="flex items-end gap-5">
                <std-button size="xs" type="primary" (click)="showModalDelete=true;currentItem=item"
                  buttonClass="rounded-full size-[30px] bg-primary focus:bg-primary hover:bg-primary text-medium !h-auto">
                  <svg class="size-[14px] fill-tertiary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path
                        d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z" />
                </svg>

                </std-button>
              </div>
            </ng-template></span>

        </std-table>

        <std-paginator customBoxSelected="!bg-primary !border-0" [total]="this.totalPages" [current]="currentPage" (pageChange)="currentPage = $event;getReceipts(mySalon)">
          <div class="h-full w-auto my-auto text-secondary" arrowLeft><</div><div arrowRight class="h-full w-auto my-auto text-secondary">></div></std-paginator>

      </div>
    </div>
  </div>
@if(showAdd){
  <std-modal cardClass="md:!w-[80vw]" modal [show]="showAdd" *transloco="let t" (close)="showAdd = false;userId = -1 ;typeReceipt = -1;servicesToBuy=[];listOfProducts = [];selectedIndexProductToAdd = -1;type=''" [closeOnOutside]="false" headerClass="bg-primary">
    <div class="text-tertiary text-normal" header>{{t('add')}}</div>
    <div content class="w-full">
      <div class="md:flex p-4 max-h-[490px] overflow-y-scroll custom-scroll gap-[2%]">
        <div class="md:w-[65%] bg-white rounded-xl shadow-md overflow-hidden">
          <div class="bg-slate-50 p-4 text-primary font-semibold text-large">Seleziona prodotto</div>

          <div class="h-[320px] w-full">
            <div class="flex h-[40px] px-[10px] gap-[2%]">
              <div
                class="w-[32%] rounded-full h-[30px] my-[5px] cursor-pointer flex items-center place-content-center text-normal text-tertiary bg-primary border-[1px] border-tertiary"
                (click)="changeType('service')">{{t('services')}}</div>
              <div
                class="w-[32%] rounded-full h-[30px] my-[5px] cursor-pointer flex items-center place-content-center text-normal text-tertiary bg-primary border-[1px] border-tertiary"
                (click)="changeType('item')">{{t('item')}}</div>
              <div
                class="w-[32%] rounded-full h-[30px] my-[5px] cursor-pointer flex items-center place-content-center text-normal text-tertiary bg-primary border-[1px] border-tertiary"
                (click)="changeType('bundle')">{{t('bundles')}}</div>
            </div>
            <div
              class="max-h-[280px] custom-scroll overflow-scroll w-full flex flex-wrap gap-y-[10px] px-[10px] gap-[2%]">
              @for (product of listOfProducts; track $index) {<div
                class="w-[32%] bg-white h-[60px] select-none rounded-md cursor-pointer border-[2px] whitespace-nowrap overflow-hidden text-ellipsis px-2 py-1 text-primary text-normal border-primary"
                [ngClass]="{'!bg-primary !text-tertiary': $index == selectedIndexProductToAdd}" [title]="product.name"
                (click)="selectedIndexProductToAdd = $index">
                <div class="w-full whitespace-nowrap overflow-hidden text-ellipsis">{{product.name}}</div>
                <div class="ml-auto text-large text-end mt-1">€ {{product.price}}</div>
              </div>}
            </div>
          </div>
          <div class="flex justify-between px-[10px] items-center  border-primary border-t-[1px]">
            <div class="w-[45%]"> <std-input customInputClass="custom-input" class="w-full" customContainerlass="w-full"
                customLabel="label-input" [type]="'number'" [(ngModel)]="amount" labelPosition="top"
                [placeholder]="t('insertValue')" [label]="t('amount')" [placeholder]="t('amount')"></std-input></div>
            <div [ngClass]="{'opacity-30 pointer-events-none': !amount}" (click)="addProductToList()"
              class="bg-primary rounded-full select-none h-[40px] border-tertiary w-[45%] p-2 text-tertiary font-semibold flex items-center place-content-center text-large cursor-pointer">
              {{t('add')}}</div>
          </div>
        </div>
        <div class="md:w-[33%] bg-white overflow-hidden rounded-xl shadow-md">
          <div class="bg-slate-50 p-4 text-primary font-semibold text-large">Ricevuta</div>
          <div class="h-[300px] custom-scroll overflow-y-scroll w-full p-4">
            @for (item of servicesToBuy; track $index) {
            <div class="mx-auto w-full p-2 bg-primary text-tertiary whitespace-nowrap rounded-md mb-2">
              <div class="whitespace-nowrap overflow-hidden text-ellipsis" [title]="item.name">{{item.name}}</div>
              <div class="text-right items-center place-content-end flex">€{{item.price}} x {{item.quantity}} <svg (click)="removeReceiptItem($index)" class="size-[14px] fill-tertiary ml-2 cursor-pointer"
                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path
                    d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z" />
                </svg></div>
            </div>
            }
          </div>
          <div class="h-[40px] w-full border-t-[1px] border-primary items-center px-[10px] flex text-primary">
            <div class="w-1/2 text-normal">{{t('total')}}</div>
            <div class="w-1/2 text-large text-right">€ {{getTotal()}}</div>
          </div>
          <div [ngClass]="{'opacity-35 pointer-events-none': typeReceipt < 0 || userId < 0 || servicesToBuy.length == 0}" (click)="addReceipt()"
            class="bg-primary p-4 text-tertiary font-semibold flex items-center place-content-center text-large cursor-pointer">
           {{t('createReceipt')}}</div>
        </div>
      </div>
      <div class="p-4 flex gap-[10%]">
        <div class="w-[45%]">
          <std-select class="max-w-full"
          (onChangeValue)="changeCustomer($event)"
          typeOfFiltrableSelect="includes"
          [filterable]="true"
          direction="up"
          customLabel="label-input"
          customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
          [label]="t('client')"
          customClassContaier="border-primary custom-select"
           [placeholder]="t('selectClient')"
          [data]="customers"
        ></std-select>
        </div>
        <div class="w-[45%]">
          <std-select class="max-w-full"
          (onChangeValue)="changeTypeReceipt($event)"
          typeOfFiltrableSelect="includes"
          [filterable]="true"
          direction="up"
          customLabel="label-input"
          customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
          [label]="t('typeReceipt')"
          customClassContaier="border-primary custom-select"
          [placeholder]="t('selectTypeReceipt')"
          [data]="
          [
            {
              label:t('receiptNTax'),
              value:0
            },
            {
              label:t('receiptTax'),
              value:1
            },
          ]"
        ></std-select>
        </div>
      </div>
    </div>
  </std-modal>}


  